import React from 'react';
import { ReactComponent as CloseIcon } from 'img/cancel-icon.svg';

import { FlexView, Row, Text } from '@cuemath/comps';
import { Divider, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import { labelBuilder } from 'utils';

const DependencyText = styled.li`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  list-style: none;
`;

const CenterDividerText = styled(Text)`
  width: 60%;
  margin: 2px auto;
`;

const Label = ({ labelData }) => {
  const { labelString } = labelBuilder(labelData) || {};
  return labelString;
};

const DependencySheetDetails = ({ dependencyData, nodeDataList }) => {
  return (
    dependencyData.length > 0 &&
    dependencyData.map((dependencyItem, index) =>
      Object.entries(dependencyItem).map(([depItemKey, depItemData]) => (
        <FlexView key={depItemKey}>
          <CenterDividerText>
            {index > 0 && (
              <Divider horizontal>
                <Header color="blue">AND</Header>
              </Divider>
            )}
          </CenterDividerText>
          <Row alignItems="center">
            <DependencyText>
              {nodeDataList[depItemKey] &&
                `${nodeDataList[depItemKey].node_type} • ${nodeDataList[depItemKey].worksheet.learnosity_activity_ref}`}
            </DependencyText>
          </Row>
          <div>{nodeDataList[depItemKey] && <Label labelData={depItemData} />}</div>
        </FlexView>
      )),
    )
  );
};

export default DependencySheetDetails;
